import axios from 'axios';

import type { BuildJsonType } from '@bb/domain/dist/typeHelpers';
import type { Covid19Settings } from '@bb/domain/dist/types';

export type GetCovid19OrgSettingsResponse = BuildJsonType<Covid19Settings>;

const getCovid19OrgSettings = async () => {
  const { data: covid19Settings } =
    await axios.get<GetCovid19OrgSettingsResponse>(`/covid19/org/settings`);

  return covid19Settings;
};

export default getCovid19OrgSettings;
